<script setup>
import { ref, reactive } from 'vue';
import { commonStore } from '@/store/common';
import { useI18n } from 'vue-i18n';
const common_store = commonStore();
import popupTitle from '@/components/popupTitle.vue';
import { Notify } from 'vant';
const { t } = useI18n();
const closeFn = () => {
  common_store.setLinkShow(false);
};
const toLink = (obj) => {
  if (obj.type == 'BinanceChain') {
    common_store.setWalletType('BinanceChain');
    common_store.initBSCWeb3();
    common_store.setLinkShow(false);
    return;
  }
  if (obj.type == 'walletConnect') {
    common_store.setWalletType('walletConnect');
    common_store.walletConnect();
    return;
  }
  if (window.ethereum && window.ethereum[obj.type]) {
    common_store.setWalletType('wallet');
    common_store.initWeb3();
    common_store.setLinkShow(false);
  } else {
    Notify({
      type: 'warning',
      message: t('connectText', { wallet: obj.title }),
      background: '#3761ea',
      color: '#fff',
    });
  }

  // swap_store.getTokenMethods();
  // common_store.setLinkShow(false);
};
let show = ref(false);
const walletArr = [
  {
    title: 'Metamask',
    type: 'isMetaMask',
    icon: require('@assets/commonImg/icon5.png'),
  },
  {
    title: 'Binance Wallet',
    type: 'BinanceChain',
    icon: require('@assets/commonImg/icon6.png'),
  },
  {
    title: 'Token Pocket',
    type: 'isTokenPocket',
    icon: require('@assets/commonImg/icon7.jpg'),
  },
  {
    title: 'imToken',
    type: 'isImToken',
    icon: require('@assets/commonImg/icon8.png'),
  },
  {
    title: 'walletConnect',
    type: 'walletConnect',
    icon: require('@assets/commonImg/icon9.svg'),
  },
];
</script>
<template>
  <div class="alert-link">
    <popup-title :title="$t('Nav.connect')" @closeFn="closeFn"></popup-title>
    <ul class="li-logo">
      <li
        v-for="(item, key) in walletArr"
        :key="key"
        class="flex_between padding iptBg"
        @click="toLink(item)"
      >
        <div class="flex_start icon">
          <img :src="item.icon" alt="" />
        </div>
        <p class="Wcolor font-Four Bold">{{ item.title }}</p>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.alert-link {
  width: 315px;
  height: 405px;
  background: url('../assets/commonImg/alert-bg3.png') no-repeat;
  background-size: 100% 100%;
  padding: 4px;
}

.close_icon {
  width: 13px;
  height: 13px;
}

.li-btn {
  .van-button {
    box-shadow: 0px 6px 6px 1px rgba(55, 97, 234, 0.5);
  }
}

.li-logo {
  padding: 0 15px;

  li {
    height: 50px;
    margin: 15px 0;
    border-radius: 5px;
  }
  img {
    width: 100%;
  }
  .icon {
    width: 30px;
  }
}
</style>
